import api from '@/shared/api/base-api';
import {
  IExternalOrderPayload,
  IOrderResponse,
  ISingleOrder,
  OrderParams,
  OrderResponse,
} from '../model/types';

export const orderApi = {
  getAll: async (
    userId: string,
    params: OrderParams
  ): Promise<OrderResponse> => {
    const { data } = await api.get(
      `/v2/aggregator-shipper/client/${userId}/order`,
      {
        params,
      }
    );
    return data;
  },

  getSingle: async (userId: string, orderId: string): Promise<ISingleOrder> => {
    const { data } = await api.get(
      `/v2/aggregator-shipper/client/${userId}/order/${orderId}`
    );
    return data;
  },

  create: async (data: Record<string, any>) => {
    const { data: response } = await api.post<IOrderResponse>(
      '/v2/aggregator-shipper/order',
      data
    );
    return response;
  },

  // getById: (id: string, config?: any) =>
  //   request.get<ISingleOrder>('/v2/order/' + id, config), from mutiwebsite

  callExternalDelivery: async (data: IExternalOrderPayload) => {
    const { data: response } = await api.post(
      `/v1/external-delivery/order/create`,
      data
    );
    return response;
  },
};

export interface ISettings {
  settings: {
    id: string;
    objectId: string;
    objectType: 'branch' | string;
    field: 'product_cooking_time' | string;
    shipperId: string;
    value?: {
      value: number | string;
    };
  }[];
}

export async function getSettings(params: {
  page: number;
  limit: number;
  object_id: string;
  object_type: string;
  fields: 'product_cooking_time';
}) {
  return api.get<ISettings>(`/v2/settings`, { params });
}
